import async from '~/utils/async';
import { createAsset, createAssetVersion } from './CreateAssetLayout.resolver';
import CreateAssetLayout from './CreateAssetLayout';

const CreateAsset = async(createAsset)(CreateAssetLayout);
const CreateAssetVersion = async(createAssetVersion)(CreateAssetLayout);

export { CreateAsset, CreateAssetVersion };
